import * as React from "react";
import { Settings20Regular } from "@fluentui/react-icons";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import {
    USAGE_GROUP_TITLE_STATE_KEY, USAGE_GROUP_ARTIST_STATE_KEY, USAGE_GROUP_COMPOSER_STATE_KEY, USAGE_GROUP_MATCH_STATUS_STATE_KEY,
    USAGE_GROUP_ALLOCATION_STATUS_STATE_KEY, USAGE_GROUP_SOURCE_MAJOR_STATE_KEY, USAGE_GROUP_SOURCE_MINOR_STATE_KEY, USAGE_GROUP_DISTRIBUTION_STATE_KEY,
    USAGE_GROUP_LICENSEE_WORK_NUMBER_STATE_KEY, USAGE_GROUP_USAGE_WEIGHT_STATE_KEY, USAGE_GROUP_USAGE_WEIGHT_CATEGORY_STATE_KEY, TITLE_EDITABLE_FIELDS_VIEW, EDITABLE_FIELDS,
    GENERAL_DATA_EDITABLE_FIELDS, USAGE_MAINTENANCE_GENERAL_DATA_VIEW, USAGE_GROUP_DISTRIBUTION_STATUS_STATE_KEY, USAGE_GROUP_DISTRIBUTION_DATE_STATE_KEY, EMPTY_STRING_VALUE, CONFIGURE_USAGES_ROLE, ALL_ROLES, USAGE_GROUP_PRODUCT_TYPE_STATE_KEY, SEARCH_VIEW, AGREEMENTS_IP_KEY,
    LOCATION_SECTION_TITLE, LOCATION_GOOGLE_VENUE, LOCATION_KNOWN_MUSIC_VENUE, LOCATION_COUNTRY, LOCATION_CITY, LOCATION_VENUE, LOCATION_EVENT_NAME, LOCATION_ADD_DETAILS_MANUALLY, SET_LIST_ADDITIONAL_SECTION_TITLE, SET_LIST_ADDITIONAL_PERFORMANCE_TYPE, SET_LIST_ADDITIONAL_STAGE,
    SET_LIST_ADDITIONAL_PROMOTER, SET_LIST_ADDITIONAL_OTHER_ARTIST_PERFORM, VENUE_DETAILS_TITLE, VENUE_DETAILS_CONTACT_FIRST_NAME, VENUE_DETAILS_CONTACT_LAST_NAME, VENUE_DETAILS_CONTACT_PHONE_NUMBER, VENUE_DETAILS_VENUE_TYPE, VENUE_DETAILS_OTHER_VENUE_TYPE, USAGE_GROUP_APPROVAL_STATUS_STATE_KEY, USAGE_GROUP_POOL_CODE_STATE_KEY, USAGE_GROUP_QA_STATUS_STATE_KEY, USAGE_GROUP_REJECT_REASON_STATE_KEY,
    CUSTOMER_ID,
    CONCERT_POINTS_TYPE,
    ATTENDEES,
    CUSTOMER_REFERENCE,
    ARTISTS_KEY,
    SET_LIST_ADDITIONAL_ARTIST_TYPE,
    SET_LIST_ADDITIONAL_VENUE_TYPE,
    CATEGORY_TWO,
    CATEGORY_ONE,
    CUSTOMER_NAME,
    CUSTOMER_CODE,
    VENUE_NAME,
    VENUE_CODE,
    ARTIST_NAME,
    ARTIST_NUMBER,
    VENUES_KEY,
    LICENSE_VENUES_KEY,
    USAGE_PAGE_VIEW,
    CONFIGURE_USAGES_DETAILS_ROLE,
    USAGE_PAGE_FORM_ITEM_SIZE,
    EXTENDED_META_DATA_USAGE_MAINTENANCE_WORK,
    USAGE_MAINTENANCE_GENERAL_DATA_VIEWS,
    LOCATION_REGION,
    MERGE_THIS_USAGE_STATE_KEY,
    USAGE_GROUP_META_DATA_STATE_KEY,
    USAGETOPRODUCT_NO_SPACES  
} from "../../../Consts";
import { showUpdateFieldsModal, hideModal, showModal } from "../../../../redux/reducers/ModalReducer";
import { SizedTextDisplay } from "../../../../core/components/textDisplay/TextDisplay";
import { setEditableFields, updateEditableFields, updateUsageField } from "../../../../redux/reducers/RepertoireReducer";
import { IShowFieldSettingViewModalProps } from "../../../components/repertoireModal/RepertoireModal";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IDistribution } from "../../../types/usageTypes/IDistribution";
import { IUsagePool } from "../../../types/usageTypes/IUsagePool";
import { stringify } from "querystring";
import { ITreeData } from "../../../types/ITreeData";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { IUsageGroupState, IUsageGroupStateKeys } from "../../../../redux/types/IUsageGroupState";
import { SizedDropdownDataInput } from "../../../components/dropdownDataInput/DropdownDataInput";
import { getLookupValues, searchLookupValueByCode } from "../../../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { USAGEMATCHSTATUS_LOOKUP, USAGE_GROUP_APPROVAL_STATUS_LOOKUP, USAGE_GROUP_QA_STATUS_LOOKUP, REJECT_REASON_TYPE_LOOKUP, LIVE_PERFORMANCE_CATEGORY, USAGE_GROUP_VENUE_TYPE_LOOKUP, USAGE_TYPE_LOOKUP, PRODUCT_TYPE_LOOKUP } from "../../../../lookup/Consts";
import { IUsageAllocations } from "../../../types/usageTypes/IUsageAllocations";
import { SizedCheckboxDataInput } from "../../../components/checkboxDataInput/CheckboxDataInput";
import IconTextButton from "../../../components/iconTextButton/IconTextButton";
import { IUsageGroupLocation } from "../../../types/usageTypes/IUsageGroupLocation";
import { IUsageGroupSetListAdditional } from "../../../types/usageTypes/IUsageGroupSetListAdditional";
import TextDataInput, { SizedTextDataInput } from "../../../components/usageComponents/textInput/TextInput";
import { IUsageGroupVenueDetails } from "../../../types/usageTypes/IUsageGroupVenueDetails";
import { IMembersPortalStateKeys } from "../../../../membersportal/types/IMembersPortalStateKeys";
import ShowMore from "../../../components/showMore/ShowMore";
import InputWithKebabMenu from "../../../components/inputWithKebabMenu/InputWithKebabMenu";
import { IArtist } from "../../../types/IArtist";
import { ICustomerVenue } from "../../../types/ISetListVenue";
import { EXTERNAL_SVG } from "../../../IconConsts";
import { ILicenseCustomerVenue } from "../../../types/ILicenseCustomerVenue";
import { IComponentView } from "../../../../redux/types/ComponentView";
import ITooltip from "../../../components/Tooltip/IToolTip";
import DropDownButtonDefaultView from "../usageSearchToolbar/DropDownButtonDefaultView";
import { IComponentViewsPreference } from "../../../../redux/types/IComponentViewsPreference";
import { IUsageRowData } from "../../../types/usageTypes/IUsageRowData";
import { IActiveExtendedData } from "../../../../redux/types/IActiveExtendedData";
import { DEFAULT_VIEW_NAME } from "../../../components/modalViews/fieldSettingView/utils/usageResultsFieldUtils";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import UsageMetaDataView from "./UsageMetaDataView";
import { Checkmark20Regular, Edit20Regular } from "@fluentui/react-icons";
import { SizedDropdownTreeDataInput } from "../../../components/dropdownTreeDataInput/DropdownTreeDataInput";

const buildUniqueCodeDropdownOptions = (
    items: ReadonlyArray<{ code: string; description?: string; }>
): { code: string; description: string; }[] => {
    const optionsByNormalizedCode = new Map<string, { code: string; description: string; }>();

    items.forEach(item => {
        const code = item.code?.trim();

        if (!code) {
            return;
        }

        const normalizedCode = code.toLowerCase();

        if (optionsByNormalizedCode.has(normalizedCode)) {
            return;
        }

        const description = item.description?.trim();
        const normalizedDescription = description?.toLowerCase();

        const descriptionAlreadyContainsCode =
            normalizedDescription === normalizedCode ||
            normalizedDescription?.startsWith(`${normalizedCode} -`);

        optionsByNormalizedCode.set(normalizedCode, {
            code,
            description: !description
                ? code
                : descriptionAlreadyContainsCode ? description : `${code} - ${description}`
        });
    });

    return Array
        .from(optionsByNormalizedCode.values())
        .sort((left, right) => String(left.code).localeCompare(String(right.code)));
};

const MAX_INITIAL_DISTRIBUTION_OPTIONS = 300;

export interface IUsageMaintenanceGeneralDataViewProps {
    usageMaintenanceGeneralDataViewData: IRepertoireComponentDataItem
    title: string;
    composer: string;
    setListArtist?: IArtist[];
    artist: string;
    distributionCode: string;
    distributions: IDistribution[];
    sourceMajor: string,
    sourceMinor: string,
    usageType: string,
    matchStatus: string,
    allocationStatus: string,
    allocations: IUsageAllocations[],
    licenseesWorkNumber: string,
    activeTab?: number;
    tabs?: ITabReduxItem[];
    isReadonly: boolean;
    usageWeight: string;
    weightCategory: string;
    editableFieldsDataView?: IRepertoireComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    hideModal?: typeof hideModal;
    showModal?: typeof showModal;
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    updateComponentFieldsItems: (fields: IRepertoireField[],
        componentName: string,
        componentInstance: string,
        componentDataFieldName: string,
        tabs: ITabReduxItem[],
        activeTab: number) => void;
    editableFields: IRepertoireField[];
    setEditableFields: typeof setEditableFields;
    lookupSources: ITreeData[];
    updateUsageField: typeof updateUsageField;
    lookupValues: ILookupDictionary;
    roles?: string[];
    productType: string;
    location?: IUsageGroupLocation;
    setListAdditional?: IUsageGroupSetListAdditional;
    updateLocation?: (newLocation: IUsageGroupLocation) => void;
    updateSetListAdditional?: (newSetListAdditional: IUsageGroupSetListAdditional) => void;
    approvalStatus?: string;
    enableApprovalStatusEdit?: boolean;
    venueDetails?: IUsageGroupVenueDetails;
    updateUsageGroupVenueDetails?: (newVenueDetails: IUsageGroupVenueDetails) => void;
    qaStatus?: string;
    rejectReason?: string;
    poolCode?: string;
    customerVenues?: ICustomerVenue[];
    catOne?: string;
    catTwo?: string;
    licenseVenues?: ILicenseCustomerVenue[];
    settingsModalViewData?: IRepertoireComponentDataItem;
    setActiveComponentView?: (activeComponentView: any) => void;
    activeComponentView?: IComponentView;
    componentViews?: any;
    showFieldsModal?: () => void;
    userHasAccess?: boolean;
    componentViewPreference?: IComponentViewsPreference;
    relatedPoolOptions?: ILookupInstance[];
    pools?: IUsagePool[];
    usages?: IUsageRowData[];
    contributorTypes?: string[];
    nameTypes?: string[];
    toggleExtendedMetaData?: (extendedMetaDataName: string, componentName: string, paneIndex?: number) => void;
    paneIndex?: number;
    activeExtendedData?: string[];
    defaultActiveExtendedData?: IActiveExtendedData[];
    mergeThisUsage: boolean;
}

interface IUsageMaintenanceGeneralDataViewState {
    loaded: boolean;
    enableEditLocation: boolean;
    newLocationValue: IUsageGroupLocation;
    enableEditSetListAdditional: boolean;
    newSetListAdditionalValue: IUsageGroupSetListAdditional;
    enableEditVenueDetails: boolean;
    newVenueDetailsValue: IUsageGroupVenueDetails;
    displayedFields?: IRepertoireField[];
    buttonComponentViews?: IComponentView[];
    userIsConfigureComponentViewAdmin?: boolean;
    isExtendedMetaDataOpen?: boolean;
    distributionSearchText?: string;
}

export default class UsageMaintenanceGeneralDataView extends React.PureComponent<
    IUsageMaintenanceGeneralDataViewProps,
    IUsageMaintenanceGeneralDataViewState> {
    viewData;
    private distributionOptionsCache: {
        distributions?: IUsageMaintenanceGeneralDataViewProps["distributions"];
        selectedDistributionCode?: string;
        distributionSearchText?: string;
        options: { code: string; description: string; }[];
    } = {
        options: []
    };

    constructor(props: IUsageMaintenanceGeneralDataViewProps) {
        super(props);

        this.state = {
            loaded: false,
            enableEditLocation: false,
            newLocationValue: {
                ...props.location
            },
            enableEditSetListAdditional: false,
            newSetListAdditionalValue: {
                ...props.setListAdditional
            },
            enableEditVenueDetails: false,
            newVenueDetailsValue: {
                ...props.venueDetails
            },
            displayedFields: props.activeComponentView?.fields?.filter(f => !f.hidden).filter(f => f.componentInstance === props.usageType) || [],
            buttonComponentViews: props.componentViews?.usageMaintenanceGeneralDataViews?.componentViews || [],
            userIsConfigureComponentViewAdmin: false,
            isExtendedMetaDataOpen: false,
            distributionSearchText: EMPTY_STRING_VALUE,
        };
        this.viewData = {};
    }

    private syncVisibleFields = () => {
        const {
            usageType,
            activeComponentView,
            componentViewPreference,
            usageMaintenanceGeneralDataViewData: { fields = [] }
        } = this.props;

        if (!usageType) {
            this.viewData = {};
            this.setState({ displayedFields: [], loaded: false });
            return;
        }

        const normalizeUsageType = (value: string): string => (value || "").replace(/\s+/g, "").toLowerCase();
        const selectedUsageType = normalizeUsageType(usageType);
        const isFieldForUsageType = (field: IRepertoireField): boolean =>
            normalizeUsageType(field.componentInstance) === selectedUsageType;

        const defaultVisibleFields = fields
            .filter(f => !f.hidden)
            .filter(isFieldForUsageType);

        const activeFields = activeComponentView?.viewName === componentViewPreference?.usageMaintenanceGeneralDataView
            ? (activeComponentView?.viewName !== DEFAULT_VIEW_NAME
                ? activeComponentView?.fields?.filter(f => !f.hidden).filter(isFieldForUsageType)
                : defaultVisibleFields)
            : (activeComponentView?.viewName === DEFAULT_VIEW_NAME
                ? defaultVisibleFields
                : activeComponentView?.fields?.filter(f => !f.hidden).filter(isFieldForUsageType));

        const fieldsToDisplay = activeFields?.length ? activeFields : defaultVisibleFields;

        this.viewData = Object.fromEntries(fieldsToDisplay.map(item => [item.name, item.data]));
        this.setState({ displayedFields: fieldsToDisplay, loaded: fieldsToDisplay.length > 0 });
    }

componentDidMount() {
    const {
        roles,
        defaultActiveExtendedData,
    } = this.props;

    const isExtendedMetaDataOpenLocal = defaultActiveExtendedData?.some(item => item.fieldName === EXTENDED_META_DATA_USAGE_MAINTENANCE_WORK && item.isExpanded);
    this.setState({ isExtendedMetaDataOpen: isExtendedMetaDataOpenLocal });
    this.syncVisibleFields();

    if (roles.includes("VIEW_COMPONENT_ROLE") || roles.includes("All") || roles.includes(CONFIGURE_USAGES_DETAILS_ROLE)) {
        this.setState({ userIsConfigureComponentViewAdmin: true });
    }
}

toggleExtendedMetaData = () => {
    this.setState(prevState => ({ isExtendedMetaDataOpen: !prevState.isExtendedMetaDataOpen }));
    this.props.toggleExtendedMetaData(EXTENDED_META_DATA_USAGE_MAINTENANCE_WORK, USAGE_MAINTENANCE_GENERAL_DATA_VIEW, this.props.paneIndex)
    }

componentDidUpdate(
    prevProps: Readonly<IUsageMaintenanceGeneralDataViewProps>
): void {
    const { 
        licenseVenues, 
        activeComponentView,
        componentViewPreference,
        componentViews, 
        roles,
        usageType,
        usageMaintenanceGeneralDataViewData: { fields = [] },
     } = this.props;

    if (prevProps.licenseVenues !== licenseVenues) {
        const firstVenue = licenseVenues?.[0];
        if (firstVenue) {
            this.setState(prevState => ({
                newVenueDetailsValue: {
                    ...prevState.newVenueDetailsValue,
                    venueCode: firstVenue.venueCode as string,
                    venueName: firstVenue.venueName
                }
            }));
        }
    }

    if (prevProps.usageType !== usageType ||
        prevProps.activeComponentView !== activeComponentView ||
        prevProps.componentViewPreference !== componentViewPreference ||
        prevProps.usageMaintenanceGeneralDataViewData?.fields !== fields) {
        this.syncVisibleFields();
    }

    const prevComponentViews = prevProps.componentViews?.usageMaintenanceGeneralDataViews?.componentViews || [];
    const currentComponentViews = componentViews?.usageMaintenanceGeneralDataViews?.componentViews || [];

    if (prevProps.componentViews !== componentViews) {
        const newButtonComponentViews = currentComponentViews.filter(view => {
  if (view.isDeleted) return false;
  if (view?.viewName === DEFAULT_VIEW_NAME) return true;
  return view.fields.some(
    (field: IRepertoireField) => !field.hidden
  );
});
        this.setState({
            buttonComponentViews: newButtonComponentViews
        });
    }
}

    onSaveEditableFields() {
        const { updateComponentFieldsItems, editableFields, tabs, activeTab, usageType } = this.props;
        updateComponentFieldsItems(editableFields["default"], USAGE_MAINTENANCE_GENERAL_DATA_VIEW, usageType, USAGE_MAINTENANCE_GENERAL_DATA_VIEW, tabs, activeTab);
    }

    showFieldsModal = () => {
        const {
            showUpdateFieldsModal,
            editableFieldsDataView,
            dataGridTableData,
            setEditableFields,
            usageType
        } = this.props;
        
        setEditableFields(USAGE_MAINTENANCE_GENERAL_DATA_VIEW, usageType)

        const fieldsViewData: IRepertoireComponentDataItem = { fields: editableFieldsDataView.fields.filter(x => x.componentInstance === GENERAL_DATA_EDITABLE_FIELDS) };
        const title: string = fieldsViewData.fields.find(item => item.name === TITLE_EDITABLE_FIELDS_VIEW).data;

        const fieldSetting: IShowFieldSettingViewModalProps = {
            componentInstance: EDITABLE_FIELDS,
            componentViewData: fieldsViewData,
            dataGridViewData: dataGridTableData,
            onClickSave: this.onSaveEditableFields.bind(this),
            key: USAGE_PAGE_VIEW,
            usageType: usageType
        }

        showUpdateFieldsModal(title, fieldSetting);
    }

    getSourceHierarchy(sourceMajor: string, sourceMinor: string) {
        return `${sourceMajor && sourceMajor}${sourceMinor && `/${sourceMinor}`}`;
    }

    getFilteredPoolOptions = (): { code: string; description: string; }[] => {
        const { pools, poolCode, relatedPoolOptions } = this.props;

        if (!pools || pools.length === 0) {
            return relatedPoolOptions || [];
        }

        const selectedSourceId = this.getSelectedSourceTreeId();
        let filteredPools: IUsagePool[] = [];

        if (selectedSourceId !== undefined && selectedSourceId !== null) {
            filteredPools = pools.filter(pool =>
                pool.sources?.some(ps => ps.source === selectedSourceId || ps.source?.toString() === selectedSourceId.toString())
            );
        } else {
            filteredPools = pools;
        }

        let options = filteredPools.map(pool => ({
            code: pool.poolCode,
            description: pool.poolCode
        }));

        if (poolCode && !options.some(opt => opt.code === poolCode)) {
            options = [{ code: poolCode, description: poolCode }, ...options];
        }

        return options;
    }

    getFilteredDistributionOptions = (selectedDistributionCode?: string, distributionSearchText?: string, isNewUsageGroup?: boolean): { code: string; description: string; }[] => {
        const { distributions, poolCode } = this.props;
        const normalizedSearchText = (distributionSearchText || EMPTY_STRING_VALUE).trim().toLowerCase();

        if (!distributions?.length) {
            return [];
        }

        let baseDistributions = distributions.filter(d => d.distributionStatus !== "Closed");

        if (isNewUsageGroup && poolCode) {
            baseDistributions = baseDistributions.filter(dist =>
                (dist.distributionPools ?? []).some(dp => dp.poolCode === poolCode)
            );
        }

        const baseItems = baseDistributions
            .map((distribution: IDistribution) => ({
                code: distribution.distributionCode,
                description: distribution.description
            }))
            .filter(item => {
                if (!normalizedSearchText) {
                    return true;
                }

                return (item.code || EMPTY_STRING_VALUE).toLowerCase().includes(normalizedSearchText) ||
                    (item.description || EMPTY_STRING_VALUE).toLowerCase().includes(normalizedSearchText);
            });

        const selectedItems = selectedDistributionCode
            ? [{ code: selectedDistributionCode, description: selectedDistributionCode }]
            : [];

        let options = buildUniqueCodeDropdownOptions([
            ...baseItems,
            ...selectedItems
        ]);

        if (!normalizedSearchText && options.length > MAX_INITIAL_DISTRIBUTION_OPTIONS) {
            const selectedOption = selectedDistributionCode
                ? options.find(option => option.code === selectedDistributionCode)
                : undefined;

            options = options.slice(0, MAX_INITIAL_DISTRIBUTION_OPTIONS);

            if (selectedOption && !options.some(option => option.code === selectedOption.code)) {
                options = [selectedOption, ...options];
            }
        }

        return options;
    }

    getSourceTreeOptions = (): ITreeData[] => {
        const { lookupSources, usageType } = this.props;

        if (!lookupSources?.length || !usageType) {
            return [];
        }

        const normalize = (value: string): string => (value || "").replace(/\s+/g, "").toLowerCase();
        const selectedUsageType = normalize(usageType);

        return lookupSources.filter((source: ITreeData) => normalize(source.matchType) === selectedUsageType);
    }

    getSelectedSourceTreeId = (): number | undefined => {
        const { sourceMajor, sourceMinor, usageType } = this.props;
        const sourceTreeOptions = this.getSourceTreeOptions();

        if (!sourceTreeOptions.length || !sourceMajor) {
            return undefined;
        }

        const normalize = (value: string): string => (value || "").replace(/\s+/g, "").toLowerCase();
        const targetUsageType = normalize(usageType);
        const targetHierarchy = `Global/${sourceMajor}${sourceMinor ? `/${sourceMinor}` : ""}`;

        const exactNode = sourceTreeOptions.find(
            (source: ITreeData) => source.hierarchy === targetHierarchy && normalize(source.matchType) === targetUsageType
        );

        if (exactNode) {
            return exactNode.id;
        }

        const majorNode = sourceTreeOptions.find((source: ITreeData) => {
            const hierarchyLevels = (source.hierarchy || "").split("/").filter(Boolean);
            return source.title === sourceMajor && hierarchyLevels.length === 3;
        });

        return majorNode?.id;
    }

    onSourceTreeChange = (value: string | string[] | boolean, changeData: any, isNewUsageGroup?: boolean): void => {
        const selectedId = typeof value === "number" || typeof value === "string" ? Number(value) : NaN;

        if (!selectedId) {
            changeData(EMPTY_STRING_VALUE, USAGE_GROUP_SOURCE_MAJOR_STATE_KEY);
            changeData(EMPTY_STRING_VALUE, USAGE_GROUP_SOURCE_MINOR_STATE_KEY);
            if (isNewUsageGroup) {
                changeData(EMPTY_STRING_VALUE, USAGE_GROUP_POOL_CODE_STATE_KEY);
                changeData(EMPTY_STRING_VALUE, "distributionCode" as IRepertoireStateKeys);
            }
            return;
        }

        const selectedSource = this.getSourceTreeOptions().find((source: ITreeData) => source.id === selectedId);

        if (!selectedSource?.hierarchy) {
            changeData(EMPTY_STRING_VALUE, USAGE_GROUP_SOURCE_MAJOR_STATE_KEY);
            changeData(EMPTY_STRING_VALUE, USAGE_GROUP_SOURCE_MINOR_STATE_KEY);
            if (isNewUsageGroup) {
                changeData(EMPTY_STRING_VALUE, USAGE_GROUP_POOL_CODE_STATE_KEY);
                changeData(EMPTY_STRING_VALUE, "distributionCode" as IRepertoireStateKeys);
            }
            return;
        }

        const hierarchy = selectedSource.hierarchy.replace("Global/", "");
        const splitString = hierarchy.split("/").filter(Boolean);

        const sourceMajor = splitString.length >= 2 ? splitString[splitString.length - 2] : splitString[0] || EMPTY_STRING_VALUE;
        const sourceMinor = splitString.length >= 2 ? splitString[splitString.length - 1] : EMPTY_STRING_VALUE;

        changeData(sourceMajor, USAGE_GROUP_SOURCE_MAJOR_STATE_KEY);
        changeData(sourceMinor, USAGE_GROUP_SOURCE_MINOR_STATE_KEY);

        if (isNewUsageGroup) {
            changeData(EMPTY_STRING_VALUE, USAGE_GROUP_POOL_CODE_STATE_KEY);
            changeData(EMPTY_STRING_VALUE, "distributionCode" as IRepertoireStateKeys);
        }
    }

    renderUsageInfo = (changeData: any, distribution: any) => {

        const {
            allocations,
            sourceMajor,
            sourceMinor,
            usageWeight,
            weightCategory,
            distributionCode,
            licenseesWorkNumber,
            lookupValues,
            isReadonly,
            matchStatus,
            catOne,
            catTwo,
            qaStatus,
            rejectReason,
            poolCode,
            setListArtist,
            productType,
            usages,
            relatedPoolOptions,
            tabs,
            activeTab,
        } = this.props

        const isNewUsageGroup = Boolean(
            tabs?.[activeTab]?.usageMaintenanceState?.isNew
        );

        const isLivePerformanceUsage = productType === 'SET LIST';

        const isAllocated =
        Array.isArray(allocations) &&
        allocations.some(x => x.allocationStatus === "Allocated");
        
        const sourceTreeOptions = this.getSourceTreeOptions();
        const selectedSourceTreeId = this.getSelectedSourceTreeId();

        const isSourceSelected = Boolean(sourceMajor || selectedSourceTreeId);
        const isPoolSelected = Boolean(poolCode && poolCode.trim().length > 0);

        const canEditPool = isNewUsageGroup
            ? isSourceSelected
            : ((!distribution || distribution?.distributionStatus === "Open") && !isAllocated);



        return (
            <div className="row flexWrapRow">
                {isLivePerformanceUsage && <SizedDropdownDataInput
                    label={this.viewData[CATEGORY_ONE]}
                    fieldName={CATEGORY_ONE}
                    value={catOne}
                    changeData={changeData}
                    options={getLookupValues(LIVE_PERFORMANCE_CATEGORY, this.props.lookupValues)}
                    allowNull={false}
                    readOnly={false}
                    isHidden={!this.viewData[CATEGORY_ONE]} />}

                {isLivePerformanceUsage && <SizedTextDataInput
                    label={this.viewData[CATEGORY_TWO]}
                    value={catTwo}
                    fieldName={CATEGORY_TWO}
                    changeData={changeData}
                    readOnly={false}
                    isHidden={!this.viewData[CATEGORY_TWO]}
                />}

                <SizedDropdownDataInput
                    label={this.viewData[USAGE_GROUP_MATCH_STATUS_STATE_KEY]}
                    fieldName={USAGE_GROUP_MATCH_STATUS_STATE_KEY}
                    value={matchStatus}
                    changeData={changeData}
                    options={getLookupValues(USAGEMATCHSTATUS_LOOKUP, lookupValues)}
                    allowNull={false}
                    readOnly={isReadonly}
                    isHidden={!this.viewData[USAGE_GROUP_MATCH_STATUS_STATE_KEY]} />

                {
                    this.props.enableApprovalStatusEdit ?
                        <SizedDropdownDataInput
                            label={this.viewData[USAGE_GROUP_APPROVAL_STATUS_STATE_KEY]}
                            fieldName={USAGE_GROUP_APPROVAL_STATUS_STATE_KEY}
                            value={this.props.approvalStatus}
                            changeData={changeData}
                            options={getLookupValues(USAGE_GROUP_APPROVAL_STATUS_LOOKUP, lookupValues)}
                            allowNull={true}
                            readOnly={isReadonly}
                            isHidden={!this.viewData[USAGE_GROUP_APPROVAL_STATUS_STATE_KEY]} /> :
                        <SizedTextDisplay
                            label={this.viewData[USAGE_GROUP_APPROVAL_STATUS_STATE_KEY]}
                            fieldName={USAGE_GROUP_APPROVAL_STATUS_STATE_KEY}
                            value={this.props.approvalStatus ? this.props.approvalStatus : 'N/A'}
                            isHidden={!this.viewData[USAGE_GROUP_APPROVAL_STATUS_STATE_KEY]}
                        />
                }

                <SizedTextDisplay
                    label={this.viewData[USAGE_GROUP_ALLOCATION_STATUS_STATE_KEY]}
                    fieldName={USAGE_GROUP_ALLOCATION_STATUS_STATE_KEY}
                    value={allocations != null && allocations.length > 0 ? 'Allocated' : 'Not Allocated'}
                    isHidden={!this.viewData[USAGE_GROUP_ALLOCATION_STATUS_STATE_KEY]}
                />

                {isNewUsageGroup ? (
                    <SizedDropdownTreeDataInput
                        label={this.viewData[USAGE_GROUP_SOURCE_MAJOR_STATE_KEY]}
                        fieldName={USAGE_GROUP_SOURCE_MAJOR_STATE_KEY}
                        value={selectedSourceTreeId}
                        changeData={(value: string | boolean | string[]) => this.onSourceTreeChange(value, changeData, isNewUsageGroup)}
                        options={sourceTreeOptions}
                        allowNull={true}
                        readOnly={false}
                        isHidden={!this.viewData[USAGE_GROUP_SOURCE_MAJOR_STATE_KEY]}
                        showSearch={true}
                    />
                ) : (
                    <SizedTextDisplay
                        label={this.viewData[USAGE_GROUP_SOURCE_MAJOR_STATE_KEY]}
                        fieldName={USAGE_GROUP_SOURCE_MAJOR_STATE_KEY}
                        value={(sourceMajor && sourceMinor) ? (this.getSourceHierarchy(sourceMajor, sourceMinor)).replace("Global/", "") : ""}
                        isHidden={!this.viewData[USAGE_GROUP_SOURCE_MAJOR_STATE_KEY]}
                    />
                )}

                <SizedDropdownDataInput
                    label={this.viewData[USAGE_GROUP_POOL_CODE_STATE_KEY]}
                    fieldName={USAGE_GROUP_POOL_CODE_STATE_KEY}
                    value={poolCode}
                    changeData={(val: string | string[] | boolean) => {
                        changeData(val, USAGE_GROUP_POOL_CODE_STATE_KEY);
                        if (isNewUsageGroup) {
                            changeData(EMPTY_STRING_VALUE, "distributionCode" as IRepertoireStateKeys);
                        }
                    }}
                    options={this.getFilteredPoolOptions()}
                    allowNull={false}
                    readOnly={!canEditPool}
                    isHidden={!this.viewData[USAGE_GROUP_POOL_CODE_STATE_KEY]}
                />
                
                {isNewUsageGroup ? (
                    <SizedDropdownDataInput
                        label={this.viewData[USAGE_GROUP_DISTRIBUTION_STATE_KEY]}
                        fieldName={"distributionCode" as IRepertoireStateKeys}
                        value={distributionCode}
                        changeData={(value: string | string[] | boolean) => {
                            const nextDistributionCode = typeof value === "string" ? value : EMPTY_STRING_VALUE;
                            changeData(nextDistributionCode, "distributionCode" as IRepertoireStateKeys);
                        }}
                        options={this.getFilteredDistributionOptions(distributionCode, this.state.distributionSearchText, isNewUsageGroup)}
                        allowNull={true}
                        readOnly={!isPoolSelected}
                        isHidden={!this.viewData[USAGE_GROUP_DISTRIBUTION_STATE_KEY]}
                        backendSearch={true}
                        onBackendSearch={(searchText: string) => {
                            this.setState({ distributionSearchText: searchText || EMPTY_STRING_VALUE });
                        }}
                    />
                ) : (
                    <SizedTextDisplay
                        label={this.viewData[USAGE_GROUP_DISTRIBUTION_STATE_KEY]}
                        fieldName={USAGE_GROUP_DISTRIBUTION_STATE_KEY}
                        value={distributionCode}
                        isHidden={!this.viewData[USAGE_GROUP_DISTRIBUTION_STATE_KEY]}
                    />
                )}

                
                {!isNewUsageGroup && (
                <SizedTextDisplay
                    label={this.viewData[USAGE_GROUP_USAGE_WEIGHT_STATE_KEY]}
                    fieldName={USAGE_GROUP_USAGE_WEIGHT_STATE_KEY}
                    value={usageWeight}
                    isHidden={!this.viewData[USAGE_GROUP_USAGE_WEIGHT_STATE_KEY]}
                />
                )}

                <SizedTextDisplay
                    label={this.viewData[USAGE_GROUP_USAGE_WEIGHT_CATEGORY_STATE_KEY]}
                    fieldName={USAGE_GROUP_USAGE_WEIGHT_CATEGORY_STATE_KEY}
                    value={weightCategory}
                    isHidden={!this.viewData[USAGE_GROUP_USAGE_WEIGHT_CATEGORY_STATE_KEY]}
                />


                {isNewUsageGroup ? (
                    <SizedTextDataInput
                        label={this.viewData[USAGE_GROUP_LICENSEE_WORK_NUMBER_STATE_KEY]}
                        value={licenseesWorkNumber}
                        fieldName={"remittingSocietyWorkCode"}
                        changeData={changeData}
                        readOnly={false}
                        isHidden={!this.viewData[USAGE_GROUP_LICENSEE_WORK_NUMBER_STATE_KEY]}
                    />
                ) : (
                    <SizedTextDisplay
                        label={this.viewData[USAGE_GROUP_LICENSEE_WORK_NUMBER_STATE_KEY]}
                        fieldName={USAGE_GROUP_LICENSEE_WORK_NUMBER_STATE_KEY}
                        value={licenseesWorkNumber}
                        isHidden={!this.viewData[USAGE_GROUP_LICENSEE_WORK_NUMBER_STATE_KEY]}
                    />
                )}

                <SizedTextDisplay
                    label={this.viewData[USAGE_GROUP_DISTRIBUTION_STATUS_STATE_KEY]}
                    fieldName={USAGE_GROUP_DISTRIBUTION_STATUS_STATE_KEY}
                    value={distribution != null && distribution.distributionStatus}
                    isHidden={!this.viewData[USAGE_GROUP_DISTRIBUTION_STATUS_STATE_KEY]}
                />

                <SizedTextDisplay
                    label={this.viewData[USAGE_GROUP_DISTRIBUTION_DATE_STATE_KEY]}
                    fieldName={USAGE_GROUP_DISTRIBUTION_DATE_STATE_KEY}
                    value={distribution != null && distribution.distributionDate != null ?
                        new Date(distribution.distributionDate).getFullYear() : EMPTY_STRING_VALUE}
                    isHidden={!this.viewData[USAGE_GROUP_DISTRIBUTION_DATE_STATE_KEY]}
                />

                <SizedDropdownDataInput
                    label={this.viewData[USAGE_GROUP_QA_STATUS_STATE_KEY]}
                    fieldName={USAGE_GROUP_QA_STATUS_STATE_KEY}
                    value={qaStatus}
                    changeData={changeData}
                    options={getLookupValues(USAGE_GROUP_QA_STATUS_LOOKUP, lookupValues)}
                    allowNull={true}
                    readOnly={isReadonly}
                    isHidden={!this.viewData[USAGE_GROUP_QA_STATUS_STATE_KEY]}
                />

                {productType == 'SET LIST' && !isNewUsageGroup &&
                    <SizedTextDisplay
                        label={this.viewData[USAGE_GROUP_REJECT_REASON_STATE_KEY]}
                        fieldName={USAGE_GROUP_REJECT_REASON_STATE_KEY}
                        value={searchLookupValueByCode(REJECT_REASON_TYPE_LOOKUP, lookupValues, rejectReason)}
                        isHidden={!this.viewData[USAGE_GROUP_REJECT_REASON_STATE_KEY]}
                    />}
            </div>
        )
    }

    renderDefaultViewDropDown = () => {
        const {
            componentViewPreference,
            setActiveComponentView,
            activeComponentView,
            settingsModalViewData
        } = this.props;
        const { buttonComponentViews } = this.state;
            return (
                <>
                    <div className="paddingRightSmall">
                        <DropDownButtonDefaultView
                            isUserAdmin={this.state.userIsConfigureComponentViewAdmin}
                            componentViewPreference={componentViewPreference}
                            setActiveComponentView={setActiveComponentView}
                            activeComponentView={activeComponentView}
                            componentViews={buttonComponentViews}
                            settingsModalViewData={settingsModalViewData}
                            showFieldsModal={this.showFieldsModal}
                            dropDownName={USAGE_MAINTENANCE_GENERAL_DATA_VIEWS}
                        />
                    </div>
                </>
            );
        
    }

    render() {
        const {
            title,
            composer,
            artist,
            distributions,
            distributionCode,
            usageType,
            productType,
            showModal,
            location,
            setListAdditional,
            venueDetails,
            lookupValues,
            usages,
            mergeThisUsage,
            activeTab,
            tabs,
        } = this.props;

        const distribution: IDistribution = distributions.find((d) => d.distributionCode === distributionCode);
        const isLivePerformanceUsage = productType === 'SET LIST';
        const hasUsageTypeSelected = Boolean(usageType && usageType.trim().length > 0);
        const isNewUsageGroup = Boolean(
            tabs?.[activeTab]?.usageMaintenanceState?.isNew
        );
        const normalizedUsageType = (usageType || "").replace(/\s+/g, "").toLowerCase();
        const isUsageToProduct = normalizedUsageType === USAGETOPRODUCT_NO_SPACES.toLowerCase();
        const needsProductTypeSelection = isNewUsageGroup && isUsageToProduct;
        const hasProductTypeSelected = Boolean(productType && productType.trim().length > 0);
        const canRenderUsageFields =
            hasUsageTypeSelected && (!needsProductTypeSelection || hasProductTypeSelected);
        const showUsageSetupRow =
            !hasUsageTypeSelected || (isNewUsageGroup && !canRenderUsageFields);
        const { loaded } = this.state;

        const changeData = (value: any, name: IRepertoireStateKeys) => {
            this.props.updateUsageField(value, name as IUsageGroupStateKeys);
        }

        const getConfigureRoleDisabled = (): boolean => {
            const { roles } = this.props;
            if (roles && (roles.includes(CONFIGURE_USAGES_DETAILS_ROLE) || roles.includes(ALL_ROLES))) {
                return false;
            }
            return true;
        }

        return (
            <>
            <div>
               <div className="row">
                <div className="editableSectionHeadingContainer">
                    <div style={ {paddingRight: '0px'}} className="col-md-12 editableSectionHeading borderBottom">
                    <h1 data-testid="usagegroup">Usage Group</h1>
                    <div className="flexRow flexAlignItemsCenter">
                    {this.renderDefaultViewDropDown()}

                                
                   {this.state.userIsConfigureComponentViewAdmin ? <button className="contributorGearBtn" title="Configure data fields"
                                    onClick={this.showFieldsModal.bind(this)}>
                                <Settings20Regular /> </button> :              <div className="flexColumn alignItemsCenter flexJustifyContentCenter"><ITooltip
                    tooltipContent={'User does not have access'}
                    showTooltip={true}
                >
                    <div style={{ paddingLeft: "6px", display: 'flex', alignItems: 'center' }} className="flexAlignItemsCenter">
                        <button className="contributorGearBtn" title="Configure data fields"
                                    onClick={this.showFieldsModal.bind(this)}
                                    disabled={true}
                                    >
                                <Settings20Regular /> </button>
                    </div>
                </ITooltip></div>  }
                     </div>
                 </div>
                 </div>
            </div>
                    {showUsageSetupRow && (
                        <div className="row">
                            <SizedDropdownDataInput
                                label="Usage Type"
                                fieldName={"usageType"}
                                value={usageType || EMPTY_STRING_VALUE}
                                changeData={changeData}
                                options={getLookupValues(USAGE_TYPE_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={false}
                                isHidden={false}
                            />

                            {isNewUsageGroup && isUsageToProduct && (
                                <SizedDropdownDataInput
                                    label={this.viewData[USAGE_GROUP_PRODUCT_TYPE_STATE_KEY] || "Product Type"}
                                    fieldName={USAGE_GROUP_PRODUCT_TYPE_STATE_KEY}
                                    value={productType || EMPTY_STRING_VALUE}
                                    changeData={changeData}
                                    options={getLookupValues(PRODUCT_TYPE_LOOKUP, lookupValues)}
                                    allowNull={true}
                                    readOnly={false}
                                    isHidden={false}
                                />
                            )}
                        </div>
                    )}
                    {loaded && canRenderUsageFields ? (
                        <>
                            <div className="row">
                                {isNewUsageGroup ? (
                                    <SizedTextDataInput
                                        label={this.viewData[USAGE_GROUP_TITLE_STATE_KEY]}
                                        value={title}
                                        fieldName={"fullTitle"}
                                        changeData={changeData}
                                        readOnly={false}
                                        isHidden={!this.viewData[USAGE_GROUP_TITLE_STATE_KEY]}
                                    />
                                ) : (
                                    <SizedTextDisplay
                                        label={this.viewData[USAGE_GROUP_TITLE_STATE_KEY]}
                                        fieldName={USAGE_GROUP_TITLE_STATE_KEY}
                                        value={title}
                                        isHidden={!this.viewData[USAGE_GROUP_TITLE_STATE_KEY]}
                                    />
                                )}

                                {isNewUsageGroup ? (
                                    <SizedTextDataInput
                                        label={this.viewData[USAGE_GROUP_COMPOSER_STATE_KEY]}
                                        value={composer}
                                        fieldName={"fullContributor"}
                                        changeData={changeData}
                                        readOnly={false}
                                        isHidden={!this.viewData[USAGE_GROUP_COMPOSER_STATE_KEY]}
                                    />
                                ) : (
                                    <SizedTextDisplay
                                        label={this.viewData[USAGE_GROUP_COMPOSER_STATE_KEY]}
                                        fieldName={USAGE_GROUP_COMPOSER_STATE_KEY}
                                        value={composer}
                                        isHidden={!this.viewData[USAGE_GROUP_COMPOSER_STATE_KEY]}
                                    />
                                )}

                                {isNewUsageGroup ? (
                                    <SizedTextDataInput
                                        label={this.viewData[USAGE_GROUP_ARTIST_STATE_KEY]}
                                        value={artist}
                                        fieldName={"fullPerformer"}
                                        changeData={changeData}
                                        readOnly={false}
                                        isHidden={!this.viewData[USAGE_GROUP_ARTIST_STATE_KEY]}
                                    />
                                ) : (
                                    <SizedTextDisplay
                                        label={this.viewData[USAGE_GROUP_ARTIST_STATE_KEY]}
                                        fieldName={USAGE_GROUP_ARTIST_STATE_KEY}
                                        value={artist}
                                        isHidden={!this.viewData[USAGE_GROUP_ARTIST_STATE_KEY]}
                                    />
                                )}

                                {isUsageToProduct &&
                                    <SizedTextDisplay
                                        label={this.viewData[USAGE_GROUP_PRODUCT_TYPE_STATE_KEY]}
                                        fieldName={USAGE_GROUP_PRODUCT_TYPE_STATE_KEY}
                                        value={productType}
                                        isHidden={!this.viewData[USAGE_GROUP_PRODUCT_TYPE_STATE_KEY]}
                                    />}
                                {!isNewUsageGroup && (
                                <SizedCheckboxDataInput
                                    label={this.viewData[MERGE_THIS_USAGE_STATE_KEY]}
                                    fieldName={MERGE_THIS_USAGE_STATE_KEY}
                                    value={mergeThisUsage}
                                    changeData={changeData}
                                    readonly={false} 
                                    isHidden={!this.viewData[MERGE_THIS_USAGE_STATE_KEY]} 
                                />
                                )}
                            </div>
                                 {this.viewData[USAGE_GROUP_META_DATA_STATE_KEY] &&   <UsageMetaDataView
                                        usageType={usageType}       
                                        contributorTypes={this.props.contributorTypes}
                                        nameTypes={this.props.nameTypes}
                                        usages={usages}
                                        toggleExtendedMetaData={this.toggleExtendedMetaData}
                                        isExtendedMetaDataOpen={this.state.isExtendedMetaDataOpen}
                                    />}

                            {productType == 'SET LIST' && <> <hr />  <div><h3>
                                <div className="flexContent flexGapSm">
                                    {this.viewData[LOCATION_SECTION_TITLE]}
                                    <IconTextButton
                                        text={""}
                                        icon={this.state.enableEditLocation ? Checkmark20Regular : Edit20Regular}
                                        onClick={() => {
                                            if (this.state.enableEditLocation)
                                                this.props.updateLocation(this.state.newLocationValue)
                                            this.setState({
                                                newVenueDetailsValue: {
                                                    ...this.state.newVenueDetailsValue,
                                                    venueCode: this.props?.licenseVenues? this.props?.licenseVenues[0]?.venueCode : '' as string,
                                                    venueName: this.props?.licenseVenues? this.props?.licenseVenues[0]?.venueName : ''
                                                }
                                            })
                                            
                                            setTimeout(() => { this.props.updateUsageGroupVenueDetails(this.state.newVenueDetailsValue); }, 500)

                                            this.setState({
                                                ...this.state,
                                                enableEditLocation: !this.state.enableEditLocation

                                            })
                                        }}
                                    />
                                </div>
                            </h3>
                                <div className="row">
                                    {
                                        this.state.enableEditLocation ?
                                            (<div className="row usageMaintenanceArtist">
                                                <SizedTextDataInput
                                                    label={this.viewData[CUSTOMER_NAME]}
                                                    value={this.props?.customerVenues && this.props?.customerVenues.length > 0 && this.props?.customerVenues[0]?.name ? this.props?.customerVenues[0]?.name :
                                                        this.props.venueDetails?.customerName ?? ''}
                                                    changeData={changeData}
                                                    readOnly={true}
                                                    isHidden={false}
                                                    fieldName={SET_LIST_ADDITIONAL_VENUE_TYPE}
                                                />
                                                <InputWithKebabMenu
                                                    variant="form"
                                                    className={USAGE_PAGE_FORM_ITEM_SIZE}
                                                    isHidden={!this.viewData[CUSTOMER_CODE]}
                                                    kebab={
                                                        <ShowMore
                                                            options={[
                                                                {
                                                                    text: "Customer",
                                                                    onClick: () => {
                                                                        showModal(SEARCH_VIEW, VENUES_KEY, { isUsageSearchArtist: true }, true, "Search");
                                                                    },
                                                                    icon: EXTERNAL_SVG,
                                                                }
                                                            ]}
                                                        />
                                                    }
                                                >
                                                    <TextDataInput
                                                        label={this.viewData[CUSTOMER_CODE]}
                                                        value={this.props?.customerVenues && this.props?.customerVenues.length > 0 && this.props?.customerVenues[0]?.code ? this.props?.customerVenues[0]?.code :
                                                            this.props.venueDetails?.customerId ?? ''}
                                                        changeData={changeData}
                                                        readOnly={true}
                                                        isHidden={false}
                                                        fieldName={SET_LIST_ADDITIONAL_VENUE_TYPE}
                                                    />
                                                </InputWithKebabMenu>
                                            </div>) : (<div className="row usageMaintenanceArtist">
                                                <SizedTextDisplay
                                                    label={this.viewData[CUSTOMER_NAME]}
                                                    fieldName={SET_LIST_ADDITIONAL_VENUE_TYPE}
                                                    value={this.props?.customerVenues && this.props?.customerVenues.length > 0 && this.props?.customerVenues[0]?.name ? this.props?.customerVenues[0]?.name :
                                                        this.props.venueDetails?.customerName ?? ''}
                                                    isHidden={!this.viewData[CUSTOMER_NAME]}
                                                />
                                                <SizedTextDisplay
                                                    label={this.viewData[CUSTOMER_CODE]}
                                                    fieldName={SET_LIST_ADDITIONAL_VENUE_TYPE}
                                                    value={this.props?.customerVenues && this.props?.customerVenues.length > 0 && this.props?.customerVenues[0]?.code ? this.props?.customerVenues[0]?.code :
                                                        this.props.venueDetails?.customerId ?? ''}
                                                    isHidden={!this.viewData[CUSTOMER_CODE]}
                                                />
                                            </div>
                                            )
                                    }
                                    {
                                        this.state.enableEditLocation ?
                                            (<div className="row usageMaintenanceArtist">
                                                <SizedTextDataInput
                                                    label={this.viewData[VENUE_NAME]}
                                                    value={
                                                        this.state.newVenueDetailsValue.venueName !== undefined
                                                            ? this.state.newVenueDetailsValue.venueName
                                                            : (
                                                                this.props?.licenseVenues &&
                                                                this.props.licenseVenues.length > 0 &&
                                                                this.props.licenseVenues[0]?.venueName
                                                            )
                                                                ? this.props.licenseVenues[0].venueName
                                                                : ''
                                                    }
                                                    isHidden={false}
                                                    fieldName={SET_LIST_ADDITIONAL_VENUE_TYPE} 
                                                    changeData={changeData}  
                                                    readOnly={true}                                              
                                                    />
                                                <InputWithKebabMenu
                                                    variant="form"
                                                    className={USAGE_PAGE_FORM_ITEM_SIZE}
                                                    isHidden={!this.viewData[VENUE_NAME]}
                                                    kebab={
                                                        <ShowMore
                                                            options={[
                                                                {
                                                                    text: "Venue",
                                                                    onClick: () => {
                                                                        showModal(SEARCH_VIEW, LICENSE_VENUES_KEY, { isUsageSearchArtist: true }, true, "Search");
                                                                    },
                                                                    icon: EXTERNAL_SVG,
                                                                }
                                                            ]}
                                                        />
                                                    }
                                                >
                                                    <TextDataInput
                                                        label={this.viewData[VENUE_CODE]}
                                                        value={
                                                            this.state.newVenueDetailsValue.venueCode !== undefined
                                                                ? this.state.newVenueDetailsValue.venueCode
                                                                : (
                                                                    this.props?.licenseVenues &&
                                                                    this.props.licenseVenues.length > 0 &&
                                                                    this.props.licenseVenues[0]?.venueCode
                                                                )
                                                                    ? this.props.licenseVenues[0].venueCode
                                                                    : ''
                                                        }
                                                        isHidden={false}
                                                        fieldName={SET_LIST_ADDITIONAL_VENUE_TYPE}
                                                        changeData={changeData} 
                                                        readOnly={true} 
                                                    />
                                                </InputWithKebabMenu>
                                            </div>) : (<div className="row usageMaintenanceArtist">
                                                <SizedTextDisplay
                                                    label={this.viewData[VENUE_NAME]}
                                                    fieldName={SET_LIST_ADDITIONAL_VENUE_TYPE}
                                                    value={
                                                        this.state.newVenueDetailsValue.venueName !== undefined
                                                            ? this.state.newVenueDetailsValue.venueName
                                                            : (
                                                                this.props?.licenseVenues &&
                                                                this.props.licenseVenues.length > 0 &&
                                                                this.props.licenseVenues[0]?.venueName
                                                            )
                                                                ? this.props.licenseVenues[0].venueName
                                                                : ''
                                                    }
                                                    isHidden={!this.viewData[VENUE_NAME]}
                                                />
                                                <SizedTextDisplay
                                                    label={this.viewData[VENUE_CODE]}
                                                    fieldName={SET_LIST_ADDITIONAL_VENUE_TYPE}
                                                    value={
                                                        this.state.newVenueDetailsValue.venueCode !== undefined
                                                            ? this.state.newVenueDetailsValue.venueCode
                                                            : (
                                                                this.props?.licenseVenues &&
                                                                this.props.licenseVenues.length > 0 &&
                                                                this.props.licenseVenues[0]?.venueCode
                                                            )
                                                                ? this.props.licenseVenues[0].venueCode
                                                                : ''
                                                    }
                                                    isHidden={!this.viewData[VENUE_CODE]}
                                                />
                                            </div>
                                            )
                                    }
                                    {!isUsageToProduct && (
                                        this.state.enableEditLocation ?
                                            <SizedTextDataInput
                                                label={this.viewData[LOCATION_GOOGLE_VENUE]}
                                                fieldName={LOCATION_GOOGLE_VENUE}
                                                value={this.state.newLocationValue.googleVenue}
                                                isHidden={!this.viewData[LOCATION_GOOGLE_VENUE]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newLocationValue: {
                                                            ...this.state.newLocationValue,
                                                            googleVenue: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[LOCATION_GOOGLE_VENUE]}
                                                fieldName={LOCATION_GOOGLE_VENUE}
                                                value={(location || { googleVenue: null }).googleVenue}
                                                isHidden={!this.viewData[LOCATION_GOOGLE_VENUE]}
                                            />
                                    )}

                                    {
                                        this.state.enableEditLocation ?
                                            <SizedTextDataInput
                                                label={this.viewData[LOCATION_KNOWN_MUSIC_VENUE]}
                                                fieldName={LOCATION_KNOWN_MUSIC_VENUE}
                                                value={this.state.newLocationValue.knownMusicVenue}
                                                isHidden={!this.viewData[LOCATION_KNOWN_MUSIC_VENUE]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newLocationValue: {
                                                            ...this.state.newLocationValue,
                                                            knownMusicVenue: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[LOCATION_KNOWN_MUSIC_VENUE]}
                                                fieldName={LOCATION_KNOWN_MUSIC_VENUE}
                                                value={(location || { knownMusicVenue: null }).knownMusicVenue}
                                                isHidden={!this.viewData[LOCATION_KNOWN_MUSIC_VENUE]}
                                            />
                                    }

                                    {
                                        this.state.enableEditLocation ?
                                            <SizedTextDataInput
                                                label={this.viewData[LOCATION_COUNTRY]}
                                                fieldName={LOCATION_COUNTRY}
                                                value={this.state.newLocationValue.country}
                                                isHidden={!this.viewData[LOCATION_COUNTRY]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newLocationValue: {
                                                            ...this.state.newLocationValue,
                                                            country: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[LOCATION_COUNTRY]}
                                                fieldName={LOCATION_COUNTRY}
                                                value={(location || { country: null }).country}
                                                isHidden={!this.viewData[LOCATION_COUNTRY]}
                                            />
                                    }

                                    {
                                        this.state.enableEditLocation ?
                                            <SizedTextDataInput
                                                label={this.viewData[LOCATION_CITY]}
                                                fieldName={LOCATION_CITY}
                                                value={this.state.newLocationValue.city}
                                                isHidden={!this.viewData[LOCATION_CITY]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newLocationValue: {
                                                            ...this.state.newLocationValue,
                                                            city: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[LOCATION_CITY]}
                                                fieldName={LOCATION_CITY}
                                                value={(location || { city: null }).city}
                                                isHidden={!this.viewData[LOCATION_CITY]}
                                            />
                                    }

                                    {
                                        this.state.enableEditLocation ?
                                            <SizedTextDataInput
                                                label={this.viewData[LOCATION_VENUE]}
                                                fieldName={LOCATION_VENUE}
                                                value={this.state.newLocationValue.venue}
                                                isHidden={!this.viewData[LOCATION_VENUE]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newLocationValue: {
                                                            ...this.state.newLocationValue,
                                                            venue: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[LOCATION_VENUE]}
                                                fieldName={LOCATION_VENUE}
                                                value={(location || { venue: null }).venue}
                                                isHidden={!this.viewData[LOCATION_VENUE]}
                                            />
                                    }

                                    {
                                        this.state.enableEditLocation ?
                                            <SizedTextDataInput
                                                label={this.viewData[LOCATION_EVENT_NAME]}
                                                fieldName={LOCATION_EVENT_NAME}
                                                value={this.state.newLocationValue.eventName}
                                                isHidden={!this.viewData[LOCATION_EVENT_NAME]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newLocationValue: {
                                                            ...this.state.newLocationValue,
                                                            eventName: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[LOCATION_EVENT_NAME]}
                                                fieldName={LOCATION_EVENT_NAME}
                                                value={(location || { location: null }).eventName}
                                                isHidden={!this.viewData[LOCATION_EVENT_NAME]}
                                            />
                                    }
                                    
                                    {
                                        this.state.enableEditLocation ?
                                            <SizedTextDataInput
                                                label={this.viewData[LOCATION_REGION]}
                                                fieldName={LOCATION_REGION}
                                                value={this.state.newLocationValue.region}
                                                isHidden={!this.viewData[LOCATION_REGION]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newLocationValue: {
                                                            ...this.state.newLocationValue,
                                                            region: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[LOCATION_REGION]}
                                                fieldName={LOCATION_REGION}
                                                value={(location || { location: null }).region}
                                                isHidden={!this.viewData[LOCATION_REGION]}
                                            />
                                    }

                                    {
                                        this.state.enableEditLocation ?
                                            <SizedCheckboxDataInput
                                                label={this.viewData[LOCATION_ADD_DETAILS_MANUALLY]}
                                                fieldName={LOCATION_ADD_DETAILS_MANUALLY}
                                                value={this.state.newLocationValue.addDetailsManually}
                                                isHidden={!this.viewData[LOCATION_ADD_DETAILS_MANUALLY]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newLocationValue: {
                                                            ...this.state.newLocationValue,
                                                            addDetailsManually: value as boolean
                                                        }
                                                    })
                                                }}
                                                inline={true}
                                            /> :
                                            <SizedCheckboxDataInput
                                                label={this.viewData[LOCATION_ADD_DETAILS_MANUALLY]}
                                                fieldName={LOCATION_ADD_DETAILS_MANUALLY}
                                                value={(location || { addDetailsManually: null }).addDetailsManually}
                                                isHidden={!this.viewData[LOCATION_ADD_DETAILS_MANUALLY]}
                                                changeData={(value: string | boolean, fieldName: string): void => { }}
                                                inline={true}
                                            />
                                    }
                                </div>
                                <hr /> </div>
                                {isLivePerformanceUsage && (<div><h3>
                                    <div className="flexContent flexGapSm">
                                        {this.viewData[SET_LIST_ADDITIONAL_SECTION_TITLE]}
                                        <IconTextButton
                                            text={""}
                                            icon={this.state.enableEditSetListAdditional ? Checkmark20Regular : Edit20Regular}
                                            onClick={() => {
                                                if (this.state.enableEditSetListAdditional)
                                                    this.props.updateSetListAdditional(this.state.newSetListAdditionalValue)

                                                this.setState({
                                                    ...this.state,
                                                    enableEditSetListAdditional: !this.state.enableEditSetListAdditional
                                                })
                                            }}
                                        />
                                    </div>
                                </h3>
                                    <div className="row">
                                        {
                                            this.state.enableEditSetListAdditional ?
                                                (<div className="row usageMaintenanceArtist">
                                                    <SizedTextDataInput
                                                        label={this.viewData[ARTIST_NAME]}
                                                        value={this.props?.setListArtist && this.props?.setListArtist.length > 0 && this.props?.setListArtist[0]?.fullName?.value ? this.props?.setListArtist[0]?.fullName?.value : ''}
                                                        changeData={changeData}
                                                        readOnly={true}
                                                        isHidden={false}
                                                        fieldName={SET_LIST_ADDITIONAL_ARTIST_TYPE}
                                                    />
                                                    <InputWithKebabMenu
                                                        variant="form"
                                                        className={USAGE_PAGE_FORM_ITEM_SIZE}
                                                        isHidden={!this.viewData[ARTIST_NUMBER]}
                                                        kebab={
                                                            <ShowMore
                                                                options={[
                                                                    {
                                                                        text: "Artist",
                                                                        onClick: () => {
                                                                            showModal(SEARCH_VIEW, ARTISTS_KEY, { isUsageSearchArtist: true }, true, "Search");
                                                                        },
                                                                        icon: EXTERNAL_SVG,
                                                                    }
                                                                ]}
                                                            />
                                                        }
                                                    >
                                                        <TextDataInput
                                                            label={this.viewData[ARTIST_NUMBER]}
                                                            value={this.props?.setListArtist && this.props?.setListArtist.length > 0 && this.props?.setListArtist[0]?.number?.value ? this.props?.setListArtist[0]?.number?.value : ''}
                                                            changeData={changeData}
                                                            readOnly={true}
                                                            isHidden={false}
                                                            fieldName={SET_LIST_ADDITIONAL_ARTIST_TYPE}
                                                        />
                                                    </InputWithKebabMenu>
                                                </div>) : (<div className="row usageMaintenanceArtist">
                                                    <SizedTextDisplay
                                                        label={this.viewData[ARTIST_NAME]}
                                                        fieldName={SET_LIST_ADDITIONAL_ARTIST_TYPE}
                                                        value={this.props?.setListArtist && this.props?.setListArtist.length > 0 && this.props?.setListArtist[0]?.fullName?.value ? this.props?.setListArtist[0]?.fullName?.value : ''}
                                                        isHidden={!this.viewData[ARTIST_NAME]}
                                                    />
                                                    <SizedTextDisplay
                                                        label={this.viewData[ARTIST_NUMBER]}
                                                        fieldName={SET_LIST_ADDITIONAL_ARTIST_TYPE}
                                                        value={this.props?.setListArtist && this.props?.setListArtist.length > 0 && this.props?.setListArtist[0]?.number?.value ? this.props?.setListArtist[0]?.number?.value : ''}
                                                        isHidden={!this.viewData[ARTIST_NUMBER]}
                                                    />
                                                </div>
                                                )
                                        }
                                        {
                                            this.state.enableEditSetListAdditional ?
                                                <SizedTextDataInput
                                                    label={this.viewData[SET_LIST_ADDITIONAL_PERFORMANCE_TYPE]}
                                                    fieldName={SET_LIST_ADDITIONAL_PERFORMANCE_TYPE}
                                                    value={this.state.newSetListAdditionalValue.performanceType}
                                                    isHidden={!this.viewData[SET_LIST_ADDITIONAL_PERFORMANCE_TYPE]}
                                                    changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                        this.setState({
                                                            ...this.state,
                                                            newSetListAdditionalValue: {
                                                                ...this.state.newSetListAdditionalValue,
                                                                performanceType: value as string
                                                            }
                                                        })
                                                    }}
                                                /> :
                                                <SizedTextDisplay
                                                    label={this.viewData[SET_LIST_ADDITIONAL_PERFORMANCE_TYPE]}
                                                    fieldName={SET_LIST_ADDITIONAL_PERFORMANCE_TYPE}
                                                    value={(setListAdditional || { performanceType: null }).performanceType}
                                                    isHidden={!this.viewData[SET_LIST_ADDITIONAL_PERFORMANCE_TYPE]}
                                                />
                                        }
                                        {
                                            this.state.enableEditSetListAdditional ?
                                                <SizedTextDataInput
                                                    label={this.viewData[SET_LIST_ADDITIONAL_STAGE]}
                                                    fieldName={SET_LIST_ADDITIONAL_STAGE}
                                                    value={this.state.newSetListAdditionalValue.stage}
                                                    isHidden={!this.viewData[SET_LIST_ADDITIONAL_STAGE]}
                                                    changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                        this.setState({
                                                            ...this.state,
                                                            newSetListAdditionalValue: {
                                                                ...this.state.newSetListAdditionalValue,
                                                                stage: value as string
                                                            }
                                                        })
                                                    }}
                                                /> :
                                                <SizedTextDisplay
                                                    label={this.viewData[SET_LIST_ADDITIONAL_STAGE]}
                                                    fieldName={SET_LIST_ADDITIONAL_STAGE}
                                                    value={(setListAdditional || { stage: null }).stage}
                                                    isHidden={!this.viewData[SET_LIST_ADDITIONAL_STAGE]}
                                                />
                                        }
                                        {
                                            this.state.enableEditSetListAdditional ?
                                                <SizedTextDataInput
                                                    label={this.viewData[SET_LIST_ADDITIONAL_PROMOTER]}
                                                    fieldName={SET_LIST_ADDITIONAL_PROMOTER}
                                                    value={this.state.newSetListAdditionalValue.promoter}
                                                    isHidden={!this.viewData[SET_LIST_ADDITIONAL_PROMOTER]}
                                                    changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                        this.setState({
                                                            ...this.state,
                                                            newSetListAdditionalValue: {
                                                                ...this.state.newSetListAdditionalValue,
                                                                promoter: value as string
                                                            }
                                                        })
                                                    }}
                                                /> :
                                                <SizedTextDisplay
                                                    label={this.viewData[SET_LIST_ADDITIONAL_PROMOTER]}
                                                    fieldName={SET_LIST_ADDITIONAL_PROMOTER}
                                                    value={(setListAdditional || { promoter: null }).promoter}
                                                    isHidden={!this.viewData[SET_LIST_ADDITIONAL_PROMOTER]}
                                                />
                                        }
                                        {
                                            this.state.enableEditSetListAdditional ?
                                                <SizedCheckboxDataInput
                                                    label={this.viewData[SET_LIST_ADDITIONAL_OTHER_ARTIST_PERFORM]}
                                                    fieldName={SET_LIST_ADDITIONAL_OTHER_ARTIST_PERFORM}
                                                    value={this.state.newSetListAdditionalValue.otherArtistPerform}
                                                    isHidden={!this.viewData[SET_LIST_ADDITIONAL_OTHER_ARTIST_PERFORM]}
                                                    changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                        this.setState({
                                                            ...this.state,
                                                            newSetListAdditionalValue: {
                                                                ...this.state.newSetListAdditionalValue,
                                                                otherArtistPerform: value as boolean
                                                            }
                                                        })
                                                    }}
                                                /> :
                                                <SizedCheckboxDataInput
                                                    label={this.viewData[SET_LIST_ADDITIONAL_OTHER_ARTIST_PERFORM]}
                                                    fieldName={SET_LIST_ADDITIONAL_OTHER_ARTIST_PERFORM}
                                                    value={(setListAdditional || { otherArtistPerform: null }).otherArtistPerform}
                                                    isHidden={!this.viewData[SET_LIST_ADDITIONAL_OTHER_ARTIST_PERFORM]}
                                                    changeData={(value: string | boolean, fieldName: string): void => { }}
                                                />
                                        }
                                    </div></div>)}


                                <hr /></>}
                            {isLivePerformanceUsage && (<div><h3>
                                <div className="flexContent flexGapSm">
                                    {this.viewData[VENUE_DETAILS_TITLE]}
                                    <IconTextButton
                                        text={""}
                                        icon={this.state.enableEditVenueDetails ? Checkmark20Regular : Edit20Regular}
                                        onClick={() => {
                                            if (this.state.enableEditVenueDetails)
                                                this.props.updateUsageGroupVenueDetails(this.state.newVenueDetailsValue)

                                            this.setState({
                                                ...this.state,
                                                enableEditVenueDetails: !this.state.enableEditVenueDetails
                                            })
                                        }}
                                    />
                                    </div>
                            </h3>                            
                                <div className="row">
                                    {
                                        this.state.enableEditVenueDetails ?
                                            <SizedTextDataInput
                                                label={this.viewData[VENUE_DETAILS_CONTACT_FIRST_NAME]}
                                                fieldName={VENUE_DETAILS_CONTACT_FIRST_NAME}
                                                value={this.state.newVenueDetailsValue.firstName}
                                                isHidden={!this.viewData[VENUE_DETAILS_CONTACT_FIRST_NAME]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newVenueDetailsValue: {
                                                            ...this.state.newVenueDetailsValue,
                                                            firstName: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[VENUE_DETAILS_CONTACT_FIRST_NAME]}
                                                fieldName={VENUE_DETAILS_CONTACT_FIRST_NAME}
                                                value={(venueDetails || { firstName: null }).firstName}
                                                isHidden={!this.viewData[VENUE_DETAILS_CONTACT_FIRST_NAME]}
                                            />
                                    }
                                    {
                                        this.state.enableEditVenueDetails ?
                                            <SizedTextDataInput
                                                label={this.viewData[VENUE_DETAILS_CONTACT_LAST_NAME]}
                                                fieldName={VENUE_DETAILS_CONTACT_LAST_NAME}
                                                value={this.state.newVenueDetailsValue.lastName}
                                                isHidden={!this.viewData[VENUE_DETAILS_CONTACT_LAST_NAME]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newVenueDetailsValue: {
                                                            ...this.state.newVenueDetailsValue,
                                                            lastName: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[VENUE_DETAILS_CONTACT_LAST_NAME]}
                                                fieldName={VENUE_DETAILS_CONTACT_LAST_NAME}
                                                value={(venueDetails || { lastName: null }).lastName}
                                                isHidden={!this.viewData[VENUE_DETAILS_CONTACT_LAST_NAME]}
                                            />
                                    }
                                    {
                                        this.state.enableEditVenueDetails ?
                                            <SizedTextDataInput
                                                label={this.viewData[VENUE_DETAILS_CONTACT_PHONE_NUMBER]}
                                                fieldName={VENUE_DETAILS_CONTACT_PHONE_NUMBER}
                                                value={this.state.newVenueDetailsValue.phoneNumber}
                                                isHidden={!this.viewData[VENUE_DETAILS_CONTACT_PHONE_NUMBER]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newVenueDetailsValue: {
                                                            ...this.state.newVenueDetailsValue,
                                                            phoneNumber: value as string
                                                        }
                                                    })
                                                }}
                                            /> :
                                            <SizedTextDisplay
                                                label={this.viewData[VENUE_DETAILS_CONTACT_PHONE_NUMBER]}
                                                fieldName={VENUE_DETAILS_CONTACT_PHONE_NUMBER}
                                                value={(venueDetails || { phoneNumber: null }).phoneNumber}
                                                isHidden={!this.viewData[VENUE_DETAILS_CONTACT_PHONE_NUMBER]}
                                            />
                                    }

                                    {
                                        this.state.enableEditVenueDetails ?
                                            <SizedTextDataInput
                                                fieldType="integer"
                                                label={this.viewData[ATTENDEES]}
                                                value={this.state.newVenueDetailsValue.attendees}
                                                fieldName={ATTENDEES}
                                                changeData={(value: string | boolean | number, fieldName: IRepertoireStateKeys | IMembersPortalStateKeys, isOnBlur?: boolean, index?: number): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newVenueDetailsValue: {
                                                            ...this.state.newVenueDetailsValue,
                                                            attendees: value as number
                                                        }
                                                    })
                                                }}
                                                readOnly={false}
                                                isHidden={!this.viewData[ATTENDEES]}
                                            />
                                            :
                                            <SizedTextDisplay
                                                label={this.viewData[ATTENDEES]}
                                                fieldName={ATTENDEES}
                                                value={(venueDetails || { attendees: null }).attendees}
                                                isHidden={!this.viewData[ATTENDEES]}
                                            />

                                    }
                                    {
                                        this.state.enableEditVenueDetails ?
                                            <SizedDropdownDataInput
                                                label={this.viewData[VENUE_DETAILS_VENUE_TYPE]}
                                                fieldName={VENUE_DETAILS_VENUE_TYPE}
                                                value={this.state.newVenueDetailsValue.venueType}
                                                isHidden={!this.viewData[VENUE_DETAILS_VENUE_TYPE]}
                                                changeData={(value: string | boolean | string[], fieldName: string): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newVenueDetailsValue: {
                                                            ...this.state.newVenueDetailsValue,
                                                            venueType: value as string
                                                        }
                                                    })
                                                }}
                                                options={getLookupValues(USAGE_GROUP_VENUE_TYPE_LOOKUP, lookupValues)}
                                                allowNull={false}
                                            />
                                            :
                                            <SizedTextDisplay
                                                label={this.viewData[VENUE_DETAILS_VENUE_TYPE]}
                                                fieldName={VENUE_DETAILS_VENUE_TYPE}
                                                value={searchLookupValueByCode(USAGE_GROUP_VENUE_TYPE_LOOKUP, lookupValues, (venueDetails || { venueType: null }).venueType)}
                                                isHidden={!this.viewData[VENUE_DETAILS_VENUE_TYPE]}
                                            />
                                    }
                                    {
                                        this.state.enableEditVenueDetails ?
                                            <SizedTextDataInput
                                                label={this.viewData[VENUE_DETAILS_OTHER_VENUE_TYPE]}
                                                fieldName={VENUE_DETAILS_OTHER_VENUE_TYPE}
                                                value={this.state.newVenueDetailsValue.otherTypeOfVenue}
                                                isHidden={!this.viewData[VENUE_DETAILS_OTHER_VENUE_TYPE]}
                                                changeData={(value: string | boolean, fieldName: string, isOnBlur?: boolean): void => {
                                                    this.setState({
                                                        ...this.state,
                                                        newVenueDetailsValue: {
                                                            ...this.state.newVenueDetailsValue,
                                                            otherTypeOfVenue: value as string
                                                        }
                                                    })
                                                }}
                                            />
                                            :
                                            <SizedTextDisplay
                                                label={this.viewData[VENUE_DETAILS_OTHER_VENUE_TYPE]}
                                                fieldName={VENUE_DETAILS_OTHER_VENUE_TYPE}
                                                value={(venueDetails || { otherTypeOfVenue: null }).otherTypeOfVenue}
                                                isHidden={!this.viewData[VENUE_DETAILS_OTHER_VENUE_TYPE]}
                                            />
                                    }
                                </div>
                                <hr /> 
                                </div>)}
                            {this.renderUsageInfo(changeData, distribution)}
                        </>
                    ) : ''}
                </div>
            </>
        );
    }
}